import React, { FC, ChangeEvent } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import styles from '../../prize.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

type IPrizeDescriptionProps = Omit<UseControllerProps, 'name'> & {
  prefixName: string;
  descDefaultValue?: string;
};

const maxLength = 1000;

const PrizeDescription: FC<IPrizeDescriptionProps> = ({ prefixName, descDefaultValue, ...props }) => {
  const name = `${prefixName}.description`;
  const { field } = useController({
    name,
    defaultValue: descDefaultValue ?? '',
    ...props,
  });

  const length = field.value?.length ?? 0;

  const placeholder = '수상 내용 및 결과를 간단히 입력해 주세요.';

  //한글 입력시 maxLength 초과되는 이슈로 인해서 onChange 이벤트 추가
  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > maxLength) {
      return;
    }

    field.onChange(e.target.value);
  };

  return (
    <div className={cx('awardWrap')}>
      <div className={cx('awardTitle')}>내용</div>

      <div className={cx('textareaWrap')}>
        <textarea {...field} placeholder={placeholder} maxLength={maxLength} rows={4} onChange={onChange} />
        <div className={cx('infoText')}>
          최대 글자수 : <span className={cx('value')}>{length}</span> / {maxLength}
        </div>
      </div>
    </div>
  );
};

export default PrizeDescription;
